import React from 'react';
import cn from 'classnames';

import { WidgetButton } from 'widget/entities/config';
import CrossIcon from 'widget/shared/icons/CrossIcon';
import { IconColor, IconSize } from 'widget/shared/icons/BaseIcon';
import ChatIcon from 'widget/shared/icons/ChatIcon';

import styles from './WidgetToggle.module.scss';

export type WidgetToggleProps = {
  isOpen?: boolean;
  onClick?: () => void;
  className?: string;
  buttonConfig?: WidgetButton;
};

export const WidgetToggle: React.FC<WidgetToggleProps> = ({
  isOpen = false,
  onClick,
  className,
  buttonConfig
}) => {
  const customIcon = buttonConfig?.iconUrl;

  const openIcon = customIcon ? (
    <img
      src={customIcon}
      alt="Widget"
      className={styles['toggle__custom-icon']}
    />
  ) : (
    <ChatIcon color={IconColor.Main} size={IconSize.XL} />
  );

  return (
    <div className={cn(styles['toggle'], className)} onClick={onClick}>
      <div
        className={cn(
          styles['toggle__icon-layer'],
          isOpen && styles['toggle__icon-layer_hidden']
        )}
      >
        {openIcon}
      </div>
      <div
        className={cn(
          styles['toggle__icon-layer'],
          !isOpen && styles['toggle__icon-layer_hidden']
        )}
      >
        <CrossIcon color={IconColor.Main} size={IconSize.XL} />
      </div>
    </div>
  );
};

export default WidgetToggle;
